// Base URL of the Express backend (subhroBackendDashboard). Every page —
// login, Dashboard, Analytics, the family/rule pages — goes through this.
//
// Keep the port here in sync with PORT in subhroBackendDashboard/.env, or
// override it without touching this file by setting REACT_APP_API_URL in
// .env.local (needed for any deploy, where the backend isn't on localhost).
const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://web.askfundu.com/api/survey',
};

export default config;


